export default {"src":"/_next/static/media/icon-5.405f1e32.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};